import React, { createContext, useContext, useState } from 'react'

const RolePreviewContext = createContext(null)

export const ROLES = [
  { value: 'admin', label: 'Admin' },
  { value: 'advisor', label: 'Advisor' },
  { value: 'broker', label: 'Broker' },
  { value: 'seller', label: 'Seller' },
  { value: 'buyer', label: 'Buyer' },
]

export function RolePreviewProvider({ children }) {
  const [previewRole, setPreviewRole] = useState(null)
  return (
    <RolePreviewContext.Provider value={{ previewRole, setPreviewRole }}>
      {children}
    </RolePreviewContext.Provider>
  )
}

export function useRolePreview() {
  const ctx = useContext(RolePreviewContext)
  return ctx
}
